<template>
  <div>
    <b-form-group label-cols="3" label="ค้นหา:" label-align="right">
      <b-form-input
        type="search"
        v-model="physicalFilter"
        placeholder="ค้นหาสินค้า จากรหัสหรือชื่อสินค้า"
      ></b-form-input>
    </b-form-group>
    <b-table
      id="PhysicalProductAdjustmentStockTable"
      ref="PhysicalProductAdjustmentStockTable"
      hover
      small
      sort-icon-left
      head-variant="light"
      :items="items"
      :fields="fields"
      :filter="physicalFilter"
      :filter-function="filterPhysical"
    >
      <template v-slot:cell(index)="row">
        <div class="d-flex align-items-center justify-content-center">
          {{ row.index + 1 }}.
        </div>
      </template>

      <template v-slot:cell(adjustmentAmount)="row">
        <InputNumberField
          :adjustStock="row.item.adjustmentAmount"
          :onChange="value => onChangeAdjustPhysicalStock(row, value)"
        />
      </template>

      <template v-slot:cell(currentStockToAfterAdjustment)="row">
        <PreAndPostStockField
          :currentStock="convertUnitStock(row)"
          :adjustStock="row.item.adjustmentAmount"
          :onChange="value => onChangeAdjustPhysicalStock(row, value)"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import PreAndPostStockField from "@/components/table/stock/fields/PreAndPostStockField.vue";
import InputNumberField from "@/components/table/stock/fields/InputNumberField.vue";

export default {
  name: "PhysicalProductAdjustmentStockTable",
  components: { PreAndPostStockField, InputNumberField },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      physicalFilter: "",
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center",
          thStyle: { width: "4%" },
          tdStyle: { width: "4%" },
        },
        {
          key: "productCode",
          label: "รหัสสินค้า",
          sortable: true,
          thStyle: { width: "14%" },
          tdStyle: { width: "14%" },
        },
        {
          key: "productNameMain",
          label: "ชื่อสินค้า",
          sortable: true,
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
        },
        {
          key: "adjustmentAmount",
          label: "จำนวนที่ปรับปรุง",
          thStyle: { width: "17%" },
          tdStyle: { width: "17%" },
        },
        {
          key: "currentStockToAfterAdjustment",
          label: "สต๊อก (ปัจจุบัน→หลังปรับปรุง)",
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "14%" },
          tdStyle: { width: "14%" },
          tdClass: "text-wrap-cell",
        },
      ],
    };
  },
  methods: {
    convertUnitStock(row) {
      return row.item.productAvailableStock;
    },
    filterPhysical(row, filter) {
      if (!filter || !String(filter).trim()) return true;
      const s = String(filter).toLowerCase();
      const code = (row.productCode || "").toString().toLowerCase();
      const name = (row.productNameMain || "").toString().toLowerCase();
      return code.includes(s) || name.includes(s);
    },
    onChangeAdjustPhysicalStock(row, value) {
      const num = Number(value);
      this.$set(row.item, "adjustmentAmount", num);
      const current = Number(row.item.productAvailableStock) || 0;
      const afterAdjustment = new BigNumber(current).plus(num).toFixed(2);
      this.$set(row.item, "currentStockToAfterAdjustment", afterAdjustment);
    },
  },
};
</script>
